
import {mapState, mapActions, mapGetters} from "pinia";
import {useRoutingStore} from '../../store.js';
import './infopanel.css';

export const InfoPanel = {
    props: {},
    data() {
        return {
            inputValue: null,
            inputStartTime: null,
            inputTimeForPoint: null
        }
    },
    computed: {
        ...mapState(useRoutingStore, [
            'RLRouteLength',
            'RLRouteDuration',
            'RLWaypoints',
            'searchStatus',
            'RLStartPoint',
            'IsCycle',
            'inputStartTimeStore',
            'selectedPoints',
            'requestsCount'

        ]),
        ...mapGetters(useRoutingStore, [
            'getRoutePoints'
        ]),
        getUpdCount(){
            if (this.IsCycle) {
                const upd = this.RLWaypoints.filter((item) => item.ID !== this.RLStartPoint.ID)
                return upd.length
            } else {
                return this.RLWaypoints.length
            }
        },
        getUpdPriceSum() {
            try {
                let updSum = null
                this.RLWaypoints.forEach(item => {
                    if (item.price) {updSum += parseFloat(item.price)}
                })
                return updSum.toFixed(2)
            } catch (error) {
                return 0
            }
        },
        getLogisticPercent(){
            return  this.inputValue ? (this.inputValue * 1.2 / this.getUpdPriceSum * 100).toFixed(2) : 0
        },
        getPriceForAddress(){
            if (this.IsCycle){
                return this.inputValue ? (this.inputValue / (parseInt(this.RLWaypoints?.length)  - 1)).toFixed(2) : 0
            }
            return this.inputValue ? (this.inputValue ?.length).toFixed(2) : 0
        },
        getPriceForKm(){
            if (this.RLRouteLength){
                return this.inputValue ? (this.inputValue / this.RLRouteLength || 0).toFixed(2) : 0
            } else {return ''}

        },
        getRLRouteEndTime(){
            if (this.inputStartTime && this.RLRouteDuration && this.inputTimeForPoint) {
                const [year, month, day, hours, minutes] = this.inputStartTime?.split(/[-T:]/);
                const date = new Date();
                date.setFullYear(year, month - 1, day)
                date.setHours(hours, minutes)
                date.setSeconds(date.getSeconds() + this.RLRouteDuration.seconds)
                const timeForAllPoints = this.inputTimeForPoint * this.getUpdCount
                date.setMinutes(date.getMinutes() + timeForAllPoints)
                return  `${date.getDate().toString().padStart(2, '0')}.${date.getMonth().toString().padStart(2, '0')}.${date.getFullYear()} 
                ${date.getHours().toString().padStart(2, '0')}
                :${date.getMinutes().toString().padStart(2, '0')}`

            }


        },
        getTimeOnRoad(){
            const fullTimeForPoint = this.RLWaypoints.length * this.inputTimeForPoint
            const fullTimeForRout = parseFloat(fullTimeForPoint) + parseFloat(this.RLRouteDuration?.seconds / 60) ? parseFloat(fullTimeForPoint) + parseFloat(this.RLRouteDuration?.seconds / 60) : 0
            const hours = fullTimeForRout / 60
            const minutes = Math.round(hours % 1 * 60)
            const timeString = `${Math.floor(hours)} ч. ${String(minutes).padStart(2, '0')} м.`
            this.setFullDuration(timeString)
            return timeString


        }
    },
    mounted() {
    },

    methods: {
        ...mapActions(useRoutingStore, [
            'setInputStartTimeStore',
            'setFullDuration',
        ]),

    },
    watch: {
        inputStartTime(newVal) {
            this.setInputStartTimeStore(newVal)

        },

    },

    // language=Vue
    template:
        `
          <div v-if="!searchStatus" class="container">
            <!-- Время старта -->
            <!--<label class="start-time">Укажите время старта маршрута: {{inputStartTime}}</label>-->
            <!--<input v-model="inputStartTime" type="datetime-local" id="start-time" required />-->

            <!-- Среднее время на ТТ -->
            <!--<label class="avg-tt-time">Среднее время на ТТ (в минутах): {{inputTimeForPoint}}</label>-->
            <!--<input v-model.number="inputTimeForPoint" type="number" id="avg-tt-time" value="15" required />-->

            <!-- Сумма доставки -->
            <!--<label class="delivery-sum">Сумма доставки:</label>-->
            <!--<input v-model.number="inputValue" type="number" id="delivery-sum" placeholder="Введите сумму" step="0.01" required />-->

            <!-- Результаты -->
            <div class="result-section">
              <div class="result-item"><span>Расстояние:</span> {{RLRouteLength ? RLRouteLength : 0}} км.</div>
              <div class="result-item"><span>Время в дороге:</span> {{getTimeOnRoad ? getTimeOnRoad : 'Проложите маршрут!' }} </div>
              <!--<div class="result-item"><span>Время завершения маршрута:</span> {{getRLRouteEndTime}} </div>-->
              <!--<div class="result-item"><span>УПД:</span> {{ getUpdCount }} шт.</div>-->
              <!--<div class="result-item"><span>Адресов:</span> {{ RLWaypoints.length }} шт.</div>-->
              <div class="result-item"><span>Выбрано:</span> {{ selectedPoints.length }}</div>
              <!--<div class="result-item"><span>Запросов:</span> {{ requestsCount }}</div>-->
              <!--<div class="result-item"><span>Сумма УПД:</span> {{ getUpdPriceSum }} руб.</div>-->
              <!--<div class="result-item"><span>% Логистики:</span> {{ getLogisticPercent }} %</div>-->
              <!--<div class="result-item"><span>Стоимость доставки 1 точки:</span> {{ getPriceForAddress }} руб.</div>-->
              <!--<div class="result-item"><span>Стоимость руб / км:</span> {{ getPriceForKm }} руб.</div>-->
            </div>
          </div>
        
        `
}

